/**
 * 登陆模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const login = {
  //用户登陆
  login_(params){
    return axios.post(`${base.baseurl.url}`,qs.stringify(params))
  },

  // 用户信息
  accInfo (params) {
    return axios.post(`${base.baseurl.url}`,qs.stringify(Object.assign(params)))
  }
}

export default login;



// WEBPACK FOOTER //
// ./src/api/request/login.js